import { Text } from '../../../cdl/Text/Text';
import { translate, TranslationKeyEn } from '../../../common/helpers/translate.helper';
import { useLocalStorageState } from '../../../common/hooks/useLocalStorageState';
import { useRole } from '../../../common/hooks/useRole';
import { IconX } from '../../../common/icons/cdl/X';
import { Section } from '../../../common/Section/Section';
import { Box } from '../../../common/ui/Box';
import { Paragraph } from '../../../common/ui/Paragraph';

// Usually, we should not use dangerouslySetInnerHTML
// In this case, it makes sense to have an easy way to integrate links inside translations.
const MultilineParagraph = ({ children }: { children: string }) => {
    if (!children) {
        return null;
    }

    return children.split('\n').map((line, key) => {
        return line ? <Paragraph dangerouslySetInnerHTML={{ __html: line }} key={key} /> : <br />;
    });
};

export const UpdateSection = () => {
    const featureName = '';
    const [viewedTimestamp, setViewedTimestamp] = useLocalStorageState(featureName, null);
    const role = useRole();

    const onCancelIconClick = () => setViewedTimestamp(new Date());

    const headlineKey = `communicationBanner.${featureName}.headline` as TranslationKeyEn;
    const descriptionKey = `communicationBanner.${featureName}.description` as TranslationKeyEn;

    const headline = translate(headlineKey);
    const description = translate(descriptionKey);

    if (!role.isCustomer()) {
        return null;
    }

    if (viewedTimestamp) {
        return null;
    }

    if (!headline || !description) {
        return null;
    }

    return (
        <Section
            title={
                <Box display="flex" alignItems="center">
                    <Text variant="title" marginLeft={4}>
                        <Text marginLeft={4}>{headline}</Text>
                    </Text>
                </Box>
            }
            actions={
                <button onClick={onCancelIconClick}>
                    <IconX />
                </button>
            }
        >
            {/* @ts-ignore */}
            <MultilineParagraph>{description}</MultilineParagraph>
        </Section>
    );
};
